export default __webpack_public_path__ + "static/media/lsi.ce8bb51e.jpg";